import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "toolbar-card mb-4" }
const _hoisted_4 = { class: "toolbar-left" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = { class: "text-muted mb-0" }
const _hoisted_7 = { class: "toolbar-right" }
const _hoisted_8 = { class: "search-shell" }
const _hoisted_9 = ["value", "placeholder"]
const _hoisted_10 = { class: "stats-grid mb-4" }
const _hoisted_11 = { class: "stat-card" }
const _hoisted_12 = { class: "stat-label" }
const _hoisted_13 = { class: "stat-value" }
const _hoisted_14 = { class: "stat-card" }
const _hoisted_15 = { class: "stat-label" }
const _hoisted_16 = { class: "stat-value text-success" }
const _hoisted_17 = { class: "stat-card" }
const _hoisted_18 = { class: "stat-label" }
const _hoisted_19 = { class: "stat-value text-primary" }
const _hoisted_20 = { class: "stat-card" }
const _hoisted_21 = { class: "stat-label" }
const _hoisted_22 = { class: "stat-value text-warning" }
const _hoisted_23 = {
  key: 0,
  class: "code-pill"
}
const _hoisted_24 = {
  key: 2,
  class: "table-copy"
}
const _hoisted_25 = {
  key: 3,
  class: "table-copy"
}
const _hoisted_26 = {
  key: 5,
  class: "d-flex justify-content-center gap-2"
}
const _hoisted_27 = ["title", "onClick"]
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = {
  key: 2,
  class: "text-muted small fw-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("promotion_page.list_title")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("promotion_page.list_description")), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("input", {
              value: _ctx.searchQuery,
              type: "text",
              class: "form-control toolbar-search",
              placeholder: _ctx.$t('promotion_page.search_placeholder'),
              onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:searchQuery', ($event.target as HTMLInputElement).value)))
            }, null, 40, _hoisted_9),
            _cache[2] || (_cache[2] = _createElementVNode("i", { class: "ri-search-line search-icon" }, null, -1))
          ]),
          (_ctx.canCreate)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn style-one btn-sm d-flex align-items-center gap-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create')))
              }, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-add-circle-line" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("promotion_page.create_button")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("promotion_page.total_promotions")), 1),
          _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.stats.total), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("promotion_page.status_active")), 1),
          _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.stats.active), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("promotion_page.customer_specific")), 1),
          _createElementVNode("strong", _hoisted_19, _toDisplayString(_ctx.stats.customerSpecific), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t("promotion_page.global")), 1),
          _createElementVNode("strong", _hoisted_22, _toDisplayString(_ctx.stats.global), 1)
        ])
      ]),
      _createVNode(_component_a_table, {
        columns: _ctx.columns,
        "data-source": _ctx.promotions,
        "row-key": 'id',
        pagination: _ctx.paginationConfig,
        loading: _ctx.loading,
        locale: { emptyText: _ctx.$t('promotion_page.no_promotions_found') },
        class: "promotion-table"
      }, {
        bodyCell: _withCtx(({ column, record, text }) => [
          (column.key === 'code')
            ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(text || _ctx.$t("promotion_page.not_available")), 1))
            : (column.key === 'customer')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(["customer-pill", record.customer_id ? 'customer-specific' : 'customer-all'])
                }, _toDisplayString(record.customer_name || _ctx.$t("promotion_page.all_customers")), 3))
              : (column.key === 'discount')
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatPromotionValue(record)), 1),
                    _createElementVNode("small", null, _toDisplayString(record.discount_type === "percentage" ? _ctx.$t("promotion_page.percentage_auto_discount") : _ctx.$t("promotion_page.fixed_auto_discount")), 1)
                  ]))
                : (column.key === 'validity')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.formatPromotionWindow(record)), 1),
                      _createElementVNode("small", null, _toDisplayString(_ctx.formatPromotionDays(record.valid_day)), 1)
                    ]))
                  : (column.key === 'status')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 4,
                        class: _normalizeClass(["status-badge", _ctx.isActive(record) ? 'status-active' : 'status-inactive'])
                      }, _toDisplayString(_ctx.isActive(record) ? _ctx.$t("promotion_page.status_active") : _ctx.$t("promotion_page.status_inactive")), 3))
                    : (column.key === 'actions')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          (_ctx.canUpdate)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "icon-btn",
                                title: _ctx.$t('promotion_page.edit'),
                                onClick: ($event: any) => (_ctx.$emit('edit', record))
                              }, [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("i", { class: "ri-pencil-line" }, null, -1)
                              ]))], 8, _hoisted_27))
                            : _createCommentVNode("", true),
                          (_ctx.canDelete)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "icon-btn danger",
                                title: _ctx.$t('promotion_page.delete'),
                                onClick: ($event: any) => (_ctx.$emit('delete', record))
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "ri-delete-bin-6-line" }, null, -1)
                              ]))], 8, _hoisted_28))
                            : _createCommentVNode("", true),
                          (!_ctx.canUpdate && !_ctx.canDelete)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("promotion_page.view_only")), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                          _createTextVNode(_toDisplayString(text || _ctx.$t("promotion_page.not_available")), 1)
                        ], 64))
        ]),
        _: 1
      }, 8, ["columns", "data-source", "pagination", "loading", "locale"])
    ])
  ]))
}